/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { SuppliersModel } from '../models';

export const AdcSuppliers: SuppliersModel[] = [
    <SuppliersModel>{
        vendorId: 5,
        title: 'Loadbalancer Enterprise',
        name: 'lbEnterprise',
        icon: 'brand-lb',
        active: true,
        platforms: [],
        // eslint-disable-next-line max-len
        description: 'adc_add_message_enterprise',
        features: [
            { name: 'warp', iconPath: 'assets/centralisedManagement/icons/running-status-connected' },
            { name: 'backup', iconPath: 'assets/centralisedManagement/icons/backup' },
            { name: 'update', iconPath: 'assets/centralisedManagement/icons/updating' },
            { name: 'security_insights_label', iconPath: 'assets/centralisedManagement/icons/security' },
        ]
    },
    <SuppliersModel>{
        vendorId: 6,
        title: 'Loadbalancer Endurance',
        name: 'lbEndurance',
        icon: 'brand-lb',
        active: true,
        description: 'adc_add_message_endurance',
        platforms: [],
    },
    <SuppliersModel>{
        vendorId: 7,
        title: 'Loadbalancer Shuttle',
        name: 'lbShuttle',
        icon: 'brand-lb',
        active: false,
        platforms: []
    },
    <SuppliersModel>{
        vendorId: 1,
        title: 'F5 BIG-IP',
        name: 'f5',
        icon: 'brand-f5',
        active: true,
        description: 'adc_add_message_f5',
        platforms: [],
        features: [
            { name: 'warp', iconPath: 'assets/centralisedManagement/icons/running-status-connected' },
            { name: 'backup', iconPath: 'assets/centralisedManagement/icons/backup' },
            { name: 'security_insights_label', iconPath: 'assets/centralisedManagement/icons/security' },
        ]
    },
    <SuppliersModel>{
        vendorId: 2,
        title: 'Kemp LoadMaster',
        name: 'kemp',
        icon: 'brand-kemp',
        active: true,
        description: 'adc_add_message_kemp',
        platforms: [],
        features: [
            { name: 'warp', iconPath: 'assets/centralisedManagement/icons/running-status-connected' },
            { name: 'backup', iconPath: 'assets/centralisedManagement/icons/backup' },
            { name: 'security_insights_label', iconPath: 'assets/centralisedManagement/icons/security' },
        ]
    },
    <SuppliersModel>{
        vendorId: 3,
        title: 'A10 Thunder ADC',
        name: 'a10ThunderAdc',
        icon: 'brand-a-10',
        active: false,
        description: 'adc_add_message_a10',
        platforms: []
    },
    <SuppliersModel>{
        vendorId: 4,
        title: 'Citrix ADC',
        name: 'citrixAdc',
        icon: 'brand-citrix',
        active: true,
        description: 'adc_add_message_citrix',
        platforms: [],
        features: [
            { name: 'warp', iconPath: 'assets/centralisedManagement/icons/running-status-connected' },
            { name: 'backup', iconPath: 'assets/centralisedManagement/icons/backup' },
            { name: 'security_insights_label', iconPath: 'assets/centralisedManagement/icons/security' },
        ]
    },
    <SuppliersModel>{
        vendorId: 8,
        title: 'Edgenexus',
        name: 'edgenexus',
        icon: 'brand-edgenexus',
        active: false,
        description: 'adc_add_message_edgenexus',
        platforms: []
    },
    <SuppliersModel>{
        vendorId: 0,
        title: 'Generic Appliance',
        name: 'genericAppliance',
        icon: 'brand-generic',
        active: true,
        description: 'adc_add_message_generic',
        platforms: [],
    }
];

